"use client";
import Icon from "./ui/Icon";
import { Dispatch, SetStateAction } from "react";

type CorePlayerProps = {
  playerRef?: any;
  currentTrack?: any;
  volume?: number;
  setVolume?: Dispatch<SetStateAction<number>>;
  isPlaying?: boolean;
  onClosePlayer?: () => void;
  onTogglePlay?: () => void;
  progress?: number;
  setProgress?: (v: number) => void;
  duration?: number;
  formatTime?: (v: number) => string;
  rewind?: () => void;
  forward?: () => void;
  nextTrack?: () => void;
  prevTrack?: () => void;
  SelectedTrackId?: () => void;
  onStopPlay?: () => void;
  setDuration?: (v: number) => void;
  onToggleCollapsed?: () => void;
  setIsVisible: (v: boolean) => void;
};

export default function CorePlayer({
  isPlaying,
  onTogglePlay,

  rewind,
  onClosePlayer,
  forward,
  nextTrack,
  prevTrack,
  onToggleCollapsed,
}: CorePlayerProps) {
  return (
    <>
      <div className="relative z-10 flex-row-reverse flex xl:flex-row items-center justify-between xl:justify-center xl:gap-x-16 mt-2.5 xl:mt-0">
        {/* controls */}
        <div className="flex items-center gap-x-8 xl:gap-x-9">
          <button
            onClick={rewind}
            className="hidden xl:flex hover:scale-110"
            aria-label="15 seconds back"
            title="15s -"
          >
            <Icon icon="FifPrev" className="size-5" />
          </button>
          <button
            onClick={nextTrack}
            aria-label="Next track"
            className="size-[45px] hover:scale-110 bg-green-05 xl:bg-transparent rounded-[18px]"
            title="Next track"
          >
            <Icon icon="Next" className="size-4" />
          </button>

          <button
            onClick={onTogglePlay}
            className="flex items-center justify-center bg-complement-05 hover:scale-110 hover:bg-complement-05/80 transition duration-150 text-white size-[45px] rounded-[18px]"
          >
            {isPlaying ? (
              <Icon icon="Pause" className="size-[14px]" />
            ) : (
              <Icon icon="Play" className="size-[14px] pl-0.5" />
            )}
          </button>
          <button
            onClick={prevTrack}
            aria-label="Previous track"
            title="Previous track"
            className="size-[45px] hover:scale-110 bg-green-05 xl:bg-transparent rounded-[18px]"
          >
            <Icon icon="Prev" className="size-4" />
          </button>
          <button
            onClick={forward}
            className="hidden xl:flex hover:scale-110"
            aria-label="15 seconds forward"
            title="15s +"
          >
            <Icon icon="FifNext" className="size-5" />
          </button>
        </div>

        <div className="flex gap-x-8">
          <button
            onClick={onClosePlayer}
            className="size-9 xl:border border-[#98B1AF] text-[#A5C293] xl:text-white hover:opacity-80 transition duration-150 rounded-xl"
          >
            <Icon icon="X" className="size-[11px]" />
          </button>
          <button
            type="button"
            onClick={onToggleCollapsed}
            className="xl:hidden flex items-center justify-center size-9 text-complement-03 hover:scale-105 transition"
            aria-label="Close media player"
            title="Close media player"
          >
            <Icon icon="CloseState" className="size-4" />
          </button>
        </div>
      </div>
    </>
  );
}
